<template>
    <div class="d-flex flex-row w-100">
        <div class="mx-1">
            <i class="fas fa-times fa-sm pointer" @click.stop="onFilterDelete(filter)"></i>
        </div>
        <div class="d-flex flex-row">
            <div class="one-third ps-1">
                <select id="fieldOptions" class="form-control small-form-control"
                        @click.stop="onFieldSelectClick" v-model="filter.field_id"
                        @change="checkFieldType(filter)">
                    <option v-for="field in table.fields" :value="field.id">{{ field.name }}</option>
                </select>
            </div>
            <div class="one-third px-1">
                <select class="form-control small-form-control"
                        @click.stop="onFieldSelectClick"
                        v-model="filter.filter_operator"
                        @change="validateFilter(filter)">
                    <option value="equals">equals</option>
                    <option value="notEqual">not equal</option>
                    <option value="greaterThan">greater than</option>
                    <option value="lessThan">less than</option>
                </select>
            </div>
            <div class="one-third pe-1">

                <select v-if="fieldType === 'Single Select'"
                        class="form-control small-form-control" v-model="filter.filter_value"
                        @change="validateFilter(filter)"
                        @click.stop="onFieldSelectClick">
                    <option v-for="fieldOption in relatedField.metadata">{{ fieldOption.value }}</option>
                </select>

                <select v-else-if="fieldType === 'Collaborator'"
                        class="form-control small-form-control" v-model="filter.filter_value"
                        @change="validateFilter(filter)"
                        @click.stop="onFieldSelectClick">
                    <option v-for="collaborator in currentApp.collaborators"
                            :value="collaborator.user_id">{{ collaborator.name }}
                    </option>
                </select>

                <select v-else-if="fieldType === 'Link to Object'"
                        class="form-control small-form-control" v-model="filter.filter_value"
                        @change="validateFilter(filter)"
                        @click.stop="onFieldSelectClick">
                    <option v-for="record in relatedDocuments"
                            :value="record.id">{{ record[primaryField.index] }}
                    </option>
                </select>

                <select v-else-if="fieldType === 'Boolean'"
                        class="form-control small-form-control"
                        v-model="filter.filter_value"
                        @change="validateFilter(filter)"
                        @click.stop="onFieldSelectClick">
                    <option value="true">true</option>
                    <option value="false">false</option>
                </select>

                <datepicker v-else-if="fieldType === 'Date'" v-model="filter.filter_value"
                            :name="table.slug + 'FilterDatepicker'"
                            @closed="dateClosed()"></datepicker>

                <input v-else type="text" class="form-control small-form-control ps-1"
                       placeholder="filter value"
                       v-model="filter.filter_value"
                       @blur="validateFilter(filter)">
            </div>
        </div>
    </div>
</template>

<script>
import TableUtil from "../../utils/TableUtil";
import FilterService from "../../services/FilterService";
//import Datepicker from 'vuejs-datepicker'
import Datepicker from 'vuejs3-datepicker';
import DateUtil from "../../utils/DateUtil";
import DataService from "../../services/DataService";
import ModelService from "../../services/ModelService";

export default {
    name: 'FilterEditor',
    components: {Datepicker},
    props: ['view', 'table', 'filter'],
    computed: {
        fieldType() {
            return this.relatedField.field_type
        },
        relatedField() {
            return this.table.fields.reduce((previousValue, currentValue) => {
                return currentValue.id === this.filter.field_id ? currentValue : previousValue;
            }, this.table.fields[0])
        },
        primaryField() {
            let tableUtil = new TableUtil()
            return tableUtil.getPrimaryField(this.linkedTable)
        },
        currentApp() {
            return this.model.app
        }
    },
    data() {
        return {
            model: webase.model,
            linkedTable: null,
            relatedDocuments: [],
            service: new FilterService()
        }
    },
    mounted() {
        if (this.filter.id) {
            let field = this.relatedField

            if (field.field_type === 'Link to Object') {
                this.loadTableData(field)
            }
        }
    },
    methods: {
        onFieldSelectClick() {
            // placeholder method
        },
        onFilterDelete(filter) {

            if (filter.id) {
                this.service.remove(this.filter.id).then(() => {
                    this.removeFilterFromList(filter)
                    webase.eventDispatcher.emit('viewUpdated', this.view)
                }).catch((message) => {
                    console.log('error deleting filter')
                    console.log(message)
                })
            } else {
                this.removeFilterFromList(filter)
            }
        },
        removeFilterFromList(filter) {
            for (let i = 0; i < this.view.filters.length; i++) {

                if (this.view.filters[i] === filter) {
                    this.view.filters.splice(i, 1)
                    break
                }
            }
        },
        checkFieldType(filter) {
            let field = this.relatedField

            if (field.field_type === 'Link to Object') {
                this.loadTableData(field)
            }

            this.validateFilter(filter)
        },
        dateClosed() {
            let dateValue = this.filter.filter_value
            let dateUtil = new DateUtil()

            if (dateUtil.isValidDate(dateValue)) {
                this.filter.filter_value = dateUtil.formatDate(dateValue)
                this.validateFilter(this.filter)
            }
        },
        validateFilter(filter) {
            if (filter.field_id && filter.filter_operator && filter.filter_value) {
                filter.view_id = this.view.id

                let request = {
                    filter: this.filter
                }

                let promise = this.filter.id === null ? this.service.create(request) : this.service.update(this.filter.id, request)

                promise.then((response) => {

                    if (!filter.id) {
                        filter.id = response.id
                    }

                    webase.eventDispatcher.emit('viewUpdated', this.view)
                }).catch((message) => {
                    console.log('error saving filter')
                    console.log(message)
                })

            }
        },

        loadTableData(field) {

            let tableId = field.related_model_id
            let modelService = new ModelService()

            modelService.get(tableId).then((response) => {
                this.linkedTable = response

                let dataService = new DataService(tableId)

                dataService.get().then((response) => {
                    this.relatedDocuments = response
                }).catch((message) => {
                    console.log('error loading data from related table')
                    console.log(message)
                })


            }).catch((message) => {
                console.log('error loading related table')
                console.log(message)
            })


            // let tableId = field.metadata.link_options.table
            //
            // let service = new DataService(tableId)
            // service.get().then((response) => {
            //
            //   console.log('Data loaded records complete')
            //   console.log(response)
            //   this.relatedDocuments = response
            //
            // }).catch((message) => {
            //   console.log('error loading related records for table ' + tableId)
            //   console.log(message)
            // })
        }
    }
}
</script>

<style>

</style>
